import { toNumber } from "@/features/account/api/mappers";
import type { NotificationCounts } from "@/features/notifications/types";

import type { NotificationCountsDto } from "./dto";

/**
 * Backend DTO → domain NotificationCounts. Defensive: every count defaults to 0,
 * negative/NaN values are clamped, and the misspelled `invitaions` key is
 * accepted as a fallback for `invitations`.
 */
export function mapNotificationCounts(
  dto: NotificationCountsDto,
): NotificationCounts {
  const count = (value: unknown) => Math.max(0, Math.trunc(toNumber(value, 0)));

  const pendingTasks = count(dto.pending_tasks);
  const invitations = count(dto.invitations ?? dto.invitaions);
  const supports = count(dto.supports);

  const ref = dto.my_referrals ?? {};

  return {
    pendingTasks,
    invitations,
    supports,
    referrals: {
      level1: count(ref.level1),
      level2: count(ref.level2),
      level3: count(ref.level3),
      total: count(ref.total_ref),
    },
    balance: toNumber(dto.balance, 0),
    total: pendingTasks + invitations + supports,
  };
}
